import apiWrapper from 'Helpers/apiWrapper'
import { encodeParams } from 'Helpers/encodeParams'
import extractApiData from 'Helpers/extractApiData'

const endpoints = ((baseURL) => {
  return {
    getListOfPecPlusConfigs: (
      status,
      pageSize,
      pageNumber,
      orderBy,
      orderDescending
    ) => `${baseURL}/api/lists/pecplus/config?${encodeParams({})}`,
    getPecPlusConfig: (idList) => `${baseURL}/api/list/${idList}/pecplus/config`
  }
})(process.env.BEPECPLUS_URL)

export const bePecPlusGetListOfPecPlusConfigs = (
  status = [],
  pageSize = 20,
  pageNumber = 1,
  orderBy = 'Id',
  orderDescending = true
) => {
  const url = endpoints.getListOfPecPlusConfigs(
    status,
    pageSize,
    pageNumber,
    orderBy,
    orderDescending
  )

  return apiWrapper({
    method: 'get',
    url
  }).then(extractApiData)
}

/**
 *
 * @typedef {Object} PecPlusConfigDetails
 * @property {number}  IdList
 * @property {string}  UserName
 * @property {string}  Email
 * @property {string}  Host
 * @property {string}  ISP
 * @property {number}  Port
 * @property {boolean}  IsCustom
 * @property {number}  Port
 * @property {string}  CreationDate
 * @property {string}  UpdateDate
 * @property {('Inprogress'|'Complete'|'Error')}  Status
 *
 *
 * @description get PEC+ configuration details
 * @param {number} idList
 * @returns {PecPlusConfigDetails} config
 */
export const bePecPlusGetPecPlusConfig = (idList) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getPecPlusConfig(idList)
  }).then(extractApiData)
}
